import React, { useMemo, useState } from 'react';
import {
  buildCreatedAtValue,
  formatTimeInputValue,
  toDateKey,
} from './foodFormUtils';

// ─── main component ─────────────────────────────────────────────────────────

const MealItemEditor = ({
  initialFood = {},
  onSubmit,
  sourceMealId = null,
  availableMeals = [],
  journalDateKey = null,
}) => {
  const [name] = useState(initialFood.name || '');
  const [targetMealId, setTargetMealId] = useState(
    sourceMealId ? String(sourceMealId) : ''
  );
  const fallbackDateKey = journalDateKey || toDateKey(new Date());
  const createdDateKey = useMemo(
    () =>
      initialFood.createdAt ? toDateKey(initialFood.createdAt) : fallbackDateKey,
    [initialFood.createdAt, fallbackDateKey]
  );
  const [createdTime, setCreatedTime] = useState(
    formatTimeInputValue(initialFood.createdAt)
  );
  const [quantity, setQuantity] = useState(initialFood.quantity || 100);

  // ── submit ─────────────────────────────────────────────────────────────
  const handleSubmit = async (event) => {
    event.preventDefault();

    onSubmit({
      quantity: Number(quantity) || 100,
      mealId: targetMealId || null,
      createdAt: buildCreatedAtValue(createdDateKey, createdTime),
    });
  };

  const mealOptions = availableMeals.filter((m) => Boolean(m?.id));
  const selectedMeal = mealOptions.find(
    (m) => String(m.id) === String(targetMealId)
  );
  const selectedFoodCount = selectedMeal ? (selectedMeal.foods || []).length : 0;

  return (
    <form id="edit-food-form" onSubmit={handleSubmit} className="food-form-improved">
      <div className="form-group">
        <label>Aliment</label>
        <div className="food-form-readonly">{name || 'Aliment'}</div>
      </div>
      <div className="form-row edit-food-row">
        <div className="form-group">
          <label>Quantité (g)</label>
          <input
            type="number"
            min={1}
            max={9999}
            value={quantity}
            onChange={(e) => setQuantity(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label>Repas</label>
          <select
            value={targetMealId}
            onChange={(e) => setTargetMealId(e.target.value)}
            required
          >
            {mealOptions.map((m) => (
              <option key={m.id} value={String(m.id)}>
                {m.name || 'Repas sans nom'}
              </option>
            ))}
          </select>
          {selectedMeal && (
            <small className="form-hint">
              {selectedFoodCount} aliment
              {selectedFoodCount > 1 ? 's' : ''} actuellement dans ce repas.
            </small>
          )}
        </div>
      </div>
      <div className="form-row edit-food-row">
        <div className="form-group">
          <label>Heure d'ajout</label>
          <input
            type="time"
            value={createdTime}
            onChange={(e) => setCreatedTime(e.target.value)}
            step={60}
            required
          />
          <small className="form-hint">
            La date d'ajout reste inchangée. Seule l'heure affichée à côté de l'aliment sera modifiée.
          </small>
        </div>
      </div>
    </form>
  );
};

export default MealItemEditor;
